import { CHAT_COMPANY } from '../constants/chat';
import { getCookie } from './cookies';

export default (isDefault?: boolean) => {
  const WORKFLOW_COMPANY_SLUG = 'workflow';
  const updatedCompany = getCookie(CHAT_COMPANY);

  return isDefault ? WORKFLOW_COMPANY_SLUG : Number(updatedCompany) || WORKFLOW_COMPANY_SLUG;
};
